'use strict';

module.exports = Backbone.Model.extend({
    defaults: {
        passengerId: -1,
        travellerName: null,
        travellerType: 'ADULT',
        requestType: '',
        baggageRows: null,
        autoSelectionAvailable: false,
        autoSelectionActive: false,
    },

    setTravellerInfo(passengersData, passengerId, defaultTravellerName) {
        let name;
        let firstLastName;
        let travellerName;

        if (passengersData[`passengers${passengerId}`]) {
            name = passengersData[`passengers${passengerId}`].name || name;
            firstLastName = passengersData[`passengers${passengerId}`].firstLastName || firstLastName;
            travellerName = passengersData[`passengers${passengerId}`].firstLastName
                ? `${name} ${firstLastName}`
                : name;
        }

        this.set('travellerName', travellerName || defaultTravellerName);
    },
});
